"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthenticatedRequest = void 0;

var _headers = require("../../state/headers");

var _getTokenHeader = _interopRequireDefault(require("../tokens/getTokenHeader"));

var _getRequestWithBoundHeaders = _interopRequireDefault(require("./getRequestWithBoundHeaders"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getAuthenticatedRequest = function getAuthenticatedRequest(client) {
  return (0, _getTokenHeader["default"])(client).then(function (tokenHeader) {
    var otherHeaders = (0, _headers.toHeadersRecord)((0, _headers.selectAllHeaders)(client.getState()));
    return (0, _getRequestWithBoundHeaders["default"])(_objectSpread({}, otherHeaders, {}, tokenHeader));
  });
};

exports.getAuthenticatedRequest = getAuthenticatedRequest;